import { CommonModule } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from "@angular/core";
import { Router } from "@angular/router";
import { KioskSetupService } from "../../services/kiosk-setup.service";
import { LedActivationService } from "../../services/led-activation.service";
import {
  KioskLocalStorageKeysEnum,
  LocalStorageService,
} from "../../services/local-storage.service";

@Component({
  selector: "db-setup",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./setup.component.html",
  styleUrls: ["./setup.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SetupComponent implements OnInit {
  private readonly kioskSetupService = inject(KioskSetupService);
  private readonly ledActivationService = inject(LedActivationService);
  private readonly localStorageService = inject(LocalStorageService);

  private readonly router = inject(Router);
  readonly LocalStorageKeys = KioskLocalStorageKeysEnum;

  readonly kioskHelpLink =
    "https://help.deskbird.com/hc/en-us/articles/29603432549009-Kiosk-Mode-for-Meeting-Rooms";

  ngOnInit(): void {
    this.checkExistingSession();
  }

  private checkExistingSession(): void {
    const refreshToken = localStorage.getItem(
      KioskLocalStorageKeysEnum.REFRESH_TOKEN,
    );
    const idToken = localStorage.getItem(KioskLocalStorageKeysEnum.ID_TOKEN);
    const roomId = localStorage.getItem(KioskLocalStorageKeysEnum.ROOM_ID);

    if (refreshToken && idToken && roomId) {
      void this.router.navigate([`rooms/${roomId}`]);
    } else {
      this.ledActivationService.setLedSetupStatus();
    }
  }

  initiateSetup(): void {
    this.localStorageService.clearTokens();
    this.kioskSetupService.getSessionId().subscribe(({ shortId }) => {
      void this.router.navigate(["qr-code"], {
        queryParams: { shortId },
      });
    });
  }
}
